/**
 * CalendarPermissionLevel
 */
export enum CalendarPermissionLevel {
    ADMIN = 'admin',
    WRITE = 'write',
    READ = 'read',
    MASKED = 'masked'
}
